import React from 'react'
import {injectIntl} from "react-intl"
import { useNavigate } from 'react-router-dom';
import unauthorizedImg from '../../assets/images/unauthorized_img.svg';

const Unauthorized = ({intl}) => {
    const navigate = useNavigate();
    return (
<div className="flex flex-col items-center h-screen px-4">
      <img
        src={unauthorizedImg}
        alt="403 Forbidden"
        className="max-w-sm w-full"
      />
      <h1 className="text-4xl font-bold text-secondary mb-2">403 - {intl.formatMessage({id:"accessDenied"})}</h1>
      <p className="text-gray-600 text-lg mb-3 text-center">
        {intl.formatMessage({id:"accessDeniedDesc"})}
      </p>
      <button
        onClick={() => navigate(-1)}
        className="px-6 py-2 bg-secondary text-white rounded-full transition"
      >
        {intl.formatMessage({id:"back"})}
      </button>
    </div>
    )
}

export default injectIntl(Unauthorized)